import React, { Fragment, useState, useEffect } from "react";
import { PaymentContainer, HyperLink } from "../../PaymentHistory/Styles";
import { TableWrapper } from "../../FinalApprover/index";
import _ from "lodash";
import queryString from "query-string";
import CustomTable from "../../../common/CustomTable/CustomTable";
import { getErrorMessage, getFileName } from "../../../../helpers/functions";
import { useSnackbar } from "notistack";
import MeetingService from "../../../../services/MeetingService";
import { PrimaryCTAButton } from "../../../common/Buttons";
import styled from "styled-components";
import { Bold } from "../../RecordingsPage";

async function getMeetingUrlArbDetails(query = "", status) {
  try {
    const response = await MeetingService.getMeetingUrlArb(query);
    const stats = {
      allCount:
        status !== "running" && status !== "notRunning" ? response?.total : 0,
      runningCount: status === "running" ? response?.total : 0,
      notRunningCount: status === "notRunning" ? response?.total : 0,
    };
    return { ...response, stats };
  } catch (error) {
    throw error;
  }
}

const initFilters = [
  { label: "All", key: "allCount", value: 0 },
  {
    label: "Running",
    key: "runningCount",
    value: 0,
  },
  { label: "Not Running", key: "notRunningCount", value: 0 },
];

const filterByStatus = (selectedFilter) => {
  let key = "";
  switch (selectedFilter) {
    case "Running":
      key = "running";
      break;
    case "Not Running":
      key = "notRunning";
      break;
    default:
      break;
  }
  return key;
};

const ArbitratorMeeting = ({ MTRef, setValue, setFieldValue, page }) => {
  const [state, setState] = useState({});
  const placeholderText = "Search meeting";
  const { enqueueSnackbar } = useSnackbar();
  const [filters, setFilters] = useState(initFilters);
  const [selectedFilter, setSelectedFilter] = useState(filters[0].label);

  useEffect(() => {
    if (MTRef.current) {
      setFieldValue("page", MTRef.current.state.query.page);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [MTRef.current]);

  useEffect(() => {
    if (selectedFilter && MTRef?.current?.onQueryChange) {
      MTRef.current.onQueryChange({
        ...MTRef.current.state.query,
        page: 0,
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilter]);

  function setStats(stats) {
    const mapped = initFilters.map((filter) => {
      let returnData = {
        label: filter.label,
      };
      if (stats[filter.key] >= 0) {
        returnData.value = stats[filter.key];
      }
      return returnData;
    });
    setFilters(mapped);
  }

  async function joinMeeting(meetingId) {
    try {
      const meetingurl = await MeetingService.joinMeeting(meetingId);
      window.open(meetingurl, "_blank");
      return;
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    }
  }

  async function deleteMeetingLink(meetingId) {
    try {
      const response = await MeetingService.deleteMeetingLink({
        id: meetingId,
      });
      enqueueSnackbar(response?.message, {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar(getErrorMessage(error), {
        variant: "error",
      });
    } finally {
      MTRef.current.onQueryChange("");
    }
  }

  const columns = [
    /*
    {
      field: "id",
      title: "Id",
      sorting: false,
      render: (rowData) => (
        <HyperLink
          style={{
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={() => {
            setValue(1);
            setFieldValue("meetingId", rowData?.id);
          }}
        >
          {rowData?.id}
        </HyperLink>
      ),
      headerStyle: {
        width: 60,
      },
      cellStyle: {
        width: 80,
      },
    },
    */
    {
      field: "arbitratorName",
      title: "Arbitrator Name",
      sorting: false,
      render: (rowData) => rowData?.arbitratorName,
    },
    {
      field: "arbitratorEmail",
      title: "Arbitrator Email",
      sorting: false,
      render: (rowData) => rowData?.arbitratorEmail,
    },
    {
      field: "arbMeetingUrl",
      title: "Recordings",
      sorting: false,
      render: (rowData) => (
        <HyperLink
          style={{
            textDecoration: "underline",
            cursor: "pointer",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
          }}
          onClick={() => {
            setValue(1);
            setFieldValue("meetingId", rowData?.id);
          }}
        >
          {getFileName(rowData?.arbMeetingUrl)}
        </HyperLink>
      ),
    },
    {
      field: "",
      title: "Join Meeting",
      sorting: false,
      render: (rowData) => (
        <PrimaryCTAButton
          style={{
            padding: "10px 10px",
            borderRadius: 10,
          }}
          onClick={() => joinMeeting(rowData?.meetingId)}
        >
          Join
        </PrimaryCTAButton>
      ),
    },
    {
      field: "",
      title: "",
      sorting: false,
      render: (rowData) => (
        <PrimaryCTAButton
          style={{
            padding: "10px 10px",
            borderRadius: 10,
          }}
          onClick={() => {
            navigator.clipboard.writeText(rowData?.arbMeetingUrl);
            enqueueSnackbar("Meeting link copied", {
              variant: "success",
            });
          }}
        >
          Copy
        </PrimaryCTAButton>
      ),
    },
    {
      field: "status",
      title: "Status",
      sorting: false,
      render: (rowData) => (
        <Bold style={{ textTransform: "capitalize" }}>
          {rowData?.running === true ? "running" : "Not running"}
        </Bold>
      ),
      headerStyle: {
        padding: `12px 16px`,
      },
      cellStyle: {
        padding: `12px 16px`,
      },
    },
    {
      field: "actions",
      title: "Action",
      sorting: false,
      headerStyle: { textAlign: "center", width: "20%" },
      cellStyle: { padding: "12px 16px", textAlign: "center" },
      render: (rowData) => (
        <DeleteButtonContainer onClick={() => deleteMeetingLink(rowData.id)}>
          <DeleteIcon>✕</DeleteIcon>
        </DeleteButtonContainer>
      ),
    },
  ];

  const data = (query) =>
    new Promise((resolve) => {
      let params = {
        page: page ? page : query.page + 1,
        perPage: 10,
        status: filterByStatus(selectedFilter),
      };
      if (query.search) {
        params.query = query.search;
      }
      if (query.orderBy?.field) {
        params.sort = query.orderBy.field;
        params.sortDirection = query.orderDirection;
      }
      let stringParams = "";
      if (!_.isEmpty(params)) {
        stringParams = `?${queryString.stringify(params)}`;
      }

      getMeetingUrlArbDetails(stringParams, params.status)
        .then(async (result) => {
          if (result) {
            resolve({
              data: result.data,
              page: result.page - 1,
              total: result.total,
            });
            setState(result);
            setStats(result.stats);
          }
        })
        .catch((error) => {
          enqueueSnackbar(getErrorMessage(error), {
            variant: "error",
          });
          setState({ data: [], lastPage: 1, page: 1, perPage: 10, total: 0 });
          resolve({
            data: [],
            page: 0,
            total: 0,
          });
        });
    });

  return (
    <Fragment>
      <PaymentContainer
        className="CreateCase"
        style={{ overflow: "hidden", marginTop: 20 }}
      >
        <TableWrapper>
          <CustomTable
            selection={false}
            hidePagination={state.lastPage === 1}
            pageSize={state?.data?.length ? state?.data?.length : 10}
            pluralTitle={"Meetings Details"}
            singularTitle=""
            {...{
              columns,
              data,
              placeholderText,
              MTRef,
              setFieldValue,
              filters,
              selectedFilter,
              setSelectedFilter,
            }}
            // hideFilterBar
            state={state}
          />
        </TableWrapper>
      </PaymentContainer>
    </Fragment>
  );
};

export default ArbitratorMeeting;

export const DeleteButtonContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background-color: #ffe8e8;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid transparent;

  &:hover {
    background-color: #d91b1b;
    transform: scale(1.05);

    & div {
      color: white;
    }
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const DeleteIcon = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #d91b1b;
  transition: color 0.3s ease;
`;
